import { Box, Typography } from '@mui/material'
import React from 'react'
import Styles from '../Config/Styles'

const Cashback = () => {
    return (
        <Box sx={Styles.products.cashbackbox}>
            <img src={require('../assets/coins_zupief.webp')} width={'20px'} height={"15px"} />
            <Typography sx={Styles.products.cashbacktypo}>High Cashback</Typography>
        </Box>
    )
}

export default Cashback